import React from "react";
import { motion } from "framer-motion";

const SkasDifference = () => {
  return (
    <div className="flex flex-col lg:flex-row bg-gray-100 p-6 lg:p-10 gap-8">
      {/* Left Section */}
      <motion.div
        className="flex-1 flex flex-col items-center lg:items-start text-center lg:text-left"
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-bold text-[#07294D] mb-4">
          The SKAS Difference
        </h2>
        <p className="text-lg text-[#07294D] mb-6">
          A premier institution fostering growth and excellence.
        </p>
        <img
          src="../../assets/school_wall_paper.jpeg"
          alt="Academy"
          className="rounded-lg shadow-lg object-cover w-full max-w-md"
        />
      </motion.div>

      {/* Right Section */}
      <motion.div
        className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-6"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {[
          {
            heading: "Excellence in Education",
            description:
              "Our programs are designed to nurture academic brilliance and lifelong learning.",
          },
          {
            heading: "Holistic Development",
            description:
              "We focus on overall growth, fostering creativity, confidence, and leadership.",
          },
          {
            heading: "Eco-Friendly Campus",
            description:
              "Experience learning in a serene, pollution-free, and green environment.",
          },
          {
            heading: "Smart Classrooms",
            description:
              "Equipped with advanced technology to enhance learning through interactive teaching methods.",
          },
        ].map((card, index) => (
          <motion.div
            key={index}
            className="bg-white shadow-md rounded-lg p-4 text-center hover:shadow-lg transition-shadow"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <h3 className="text-xl font-semibold text-[#07294D] mb-2">
              {card.heading}
            </h3>
            <p className="text-[#07294D]">{card.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default SkasDifference;
